import { Hotel } from '@/entities/hotel';
import Button from '@/shared/components/shared/Button';
import HotelCard from '@/shared/components/shared/HotelCard';
import Link from '@/shared/components/shared/Link';
import Reveal from '../../shared/Reveal';
import Typografed from '../../shared/Typografed';

export type HotelsSectionProps = {
    title: string;
    subtitle: string;
    linkText: string;
    linkURL: string;
    hotels: Hotel[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    hotelsSectionProps: HotelsSectionProps;
};

const HotelsSection = ({ hotelsSectionProps }: Props) => {
    const { title, subtitle, hotels, linkText, linkURL } = hotelsSectionProps;

    return (
        <section
            className="hotel-section wrapper js-header-theme-trigger js-bg-trigger-light"
            data-bg="#fff"
            data-theme="dark"
            data-offset="none"
            id="hotels"
        >
            <div className="hotel-section__left">
                <div className="hotel-section__content">
                    <div className="hotel-section-title h4">
                        <Typografed>{title}</Typografed>
                    </div>
                    <div className="hotel-section__content-wrapper">
                        {subtitle && (
                            <div className="text-with-image__text">
                                <Typografed>{subtitle}</Typografed>
                            </div>
                        )}
                        <Button
                            tag={Link}
                            href={linkURL}
                            target="_blank"
                            rel="noreferrer nofollow"
                            variant={`outline-dark`}
                            className="btn btn-outline-dark"
                        >
                            {linkText}
                        </Button>
                    </div>
                </div>
            </div>

            <div className="hotel-section__right">
                {hotels.length > 0 ? (
                    <ul className="hotel-section__list list-unstyled">
                        {hotels.map((item: Hotel) => (
                            <li key={item.id}>
                                <Reveal>
                                    <HotelCard cardInfo={item} />
                                </Reveal>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="hotel-section__empty">
                        <Typografed>Гостиницы не найдены</Typografed>
                    </div>
                )}
            </div>
        </section>
    );
};

export default HotelsSection;
